import styled from 'styled-components'

export const Root = styled.button`
  background-color: #fff;
  color: #000;
  border: none;
  padding: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
`
